export enum WizardStepperEnum {
    UNMARKED = 'UNMARKED',
    COMPLETED = 'COMPLETED',
    CURRENT = 'CURRENT'
}
